import conditions from '../../assets/files/en/terms-of-user-data-processing-on-the-websites-of-Bank-131-JSC.pdf';
import policy from "../../assets/files/en/personal_data_processing_policy.pdf";

export default {
  businessSolutions: "Business solutions",
  contactsPage: "\"Contacts page\"",
  feedback: "Feedback",
  payouts: "Payouts",
  onlinePayments: "Online payments",
  splitPaymentForMarketplaces: "Split payment for marketplaces",
  developers: "Developers",
  pricing: "Pricing",
  company: "Company",
  financialSecurity: "Financial Security",
  aboutBank: "About Bank 131",
  vacancy: "Careers",
  termsOfUserDataProcessing: "Terms of user data processing on the website",
  termsOfUserDataProcessingLink: conditions,
  personalDataProcessingPolicy: "Personal Data Processing Policy",
  personalDataProcessingPolicyLink: policy,
  blog: "Blog",
  legalInformation: "Legal information",
  email: "Email",
  techSupport: "Technical support",
  workSchedule: "open daily, from 9:00 to 20:00 Moscow time",
  onTheWebsite: "on the website",
  additionalWayToSubmitRequestsTitle: "Additional channels for customer inquiries:",
  additionalWayToSubmitRequests: "Inquiry form on the",
  remoteBankingSystem: "Remote banking service system «Internet-Klient» (for legal entities based on the concluded agreement)",
  address: "Address",
  officeAddress: "420012, 38 Nekrasova street, Kazan, Republic of Tatarstan, Russian Federation",
  phoneNumber: "8 800 100 13 10",
  phoneNumberDescription: "call within Russia is free",
  addressesForReceivingRequests: "Addresses for receiving requests",
  contactUs: "Contact us",
  contactsForDirectingApplicationsToTheBank: "Contacts for directing applications to the bank",
  workingWithInternetBanking: "Working with Internet banking",
  weAreInSocial: "WE ARE IN SOCIAL NETWORKS",
  ideasAndPartnerships: "Ideas and partnerships",
  media: "Media",
  instructions: "Instructions",
  insuranceInfo: "АО «Банк 131» является участником системы страхования вкладов",
  insuranceInfoLinkText: "Информация о процентных ставках по договорам банковского вклада с физическими лицами",
  copyright: "© 2019-{{currentYear}} Bank 131 JSC, official website. Banking license No. 3538 dated November 29, 2024.",
  splitPayment: "Split payment",
  faq: "FAQ",
  forSelfEmployed: "For Self Employed",
  onlineBank: "Online Banking for Business",
  bankAccount: "Bank Account",
  escrowAccount: "Escrow account",
  paymentBot: "Receive payments in Telegram",
  mainMenuItems: [
    [
      {
        title: "Payouts",
        url: "/en/products/payouts",
        icon: "Wallet.svg"
      },
      {
        title: "Online payments",
        url: "/en/products/payments",
        icon: "Card.svg"
      },
      {
        title: "Online Banking for Business",
        url: "/en/products/online-banking",
        icon: "onlineBanking.svg"
      }
    ],
    [
      {
        title: "Split payment for marketplaces",
        url: "/en/products/marketplaces",
        icon: "SplitPayment.svg"
      },
      {
        title: "Faster Payments System",
        url: "/en/products/sbp",
        icon: "SBP.svg"
      },
      {
        title: "Bank Account",
        url: "/en/products/account",
        icon: "Account.svg"
      }
    ],
    [
      {
        title: "Escrow account",
        url: "/en/products/escrow-account",
        icon: "EscrowAccount.svg"
      }
    ]
  ]
};
